<template>
  <v-data-table class="elevation-10" v-model="selected" :headers="headers" :items="invoices" :server-items-length="total" @pagination="onPagination"
                :options.sync="options" :loading="loading" :footer-props="{ itemsPerPageOptions: limitOptions }" :show-select="showSelect" item-key="documentUniqueId">
    <template v-slot:top>
      <v-container fluid>
        <v-row class="pa-0">
          <v-col cols="12" md="4" lg="3" class="pa-0">
            <v-autocomplete
                v-model="filters.contractor"
                :items.sync="contractions"
                :search-input.sync="searchContractor"
                :loading="loadingContractor"
                :clearable="true"
                item-text="name"
                item-value="inn"
                :filter="filterContractions"
                label="Поиск по инн и названия контрагента"
                class="mx-4"
                @change="onSelectContraction()"
            >

              <template slot="selection" slot-scope="data">
                <span class="mr-2">{{ data.item.inn }}</span>
                <b>{{ data.item.name }}</b>
              </template>
              <template slot="item" slot-scope="data">
                <span class="mr-2">{{ data.item.inn }}</span>
                <b>{{ data.item.name }}</b>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="3" class="pa-0">
            <v-text-field
                placeholder="Номер счёт-фактуры"
                v-model="searchInvoiceNumber"
                @input="searchInvoiceNumberInput"
            />
          </v-col>
          <v-col cols="12" md="4" lg="3" class="pa-0">
            <v-menu
                :close-on-content-click="true"
                v-model="filterInvoiceDateMenu"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{on}">
                <v-text-field label="Дата счёт-фактуры" v-model="filters.invoiceDate" prepend-icon="event" :append-icon="filters.invoiceDate ? 'clear' : null" v-on:click:append="filters.invoiceDate = null"
                              class="ml-2"
                              readonly
                              v-on="on"
                />
              </template>
              <v-date-picker v-model="filters.invoiceDate" no-title scrollable locale="ru" first-day-of-week="1"/>
            </v-menu>
          </v-col>
          <v-col cols="12" md="4" lg="3" class="pa-0" v-if="allowSignedDateFilter">
            <v-menu
                :close-on-content-click="true"
                v-model="filterSignedDateMenu"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{on}">
                <v-text-field
                    label="Дата подписания"
                    v-model="filters.signedDate"
                    prepend-icon="event"
                    :append-icon="filters.signedDate ? 'clear' : null"
                    v-on:click:append="filters.signedDate = null"
                    class="ml-2"
                    readonly
                    v-on="on"
                />
              </template>
              <v-date-picker
                  v-model="filters.signedDate"
                  no-title
                  scrollable
                  locale="ru"
                  first-day-of-week="1"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" md="4" lg="3" class="pa-0" v-if="allowSignedDateFilter">
            <v-menu
                :close-on-content-click="true"
                v-model="filterSignedDateMenu"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{on}">
                <v-text-field
                    label="Дата подписания"
                    v-model="filters.signedDate"
                    prepend-icon="event"
                    :append-icon="filters.signedDate ? 'clear' : null"
                    v-on:click:append="filters.signedDate = null"
                    class="ml-2"
                    readonly
                    v-on="on"
                />
              </template>
              <v-date-picker
                  v-model="filters.signedDate"
                  no-title
                  scrollable
                  locale="ru"
                  first-day-of-week="1"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" md="4" lg="3" class="pa-0" v-if="allowBranchFilter">
            <v-autocomplete
                v-model="filters.branch"
                :items="$store.getters.useBranches"
                :item-text="item => {return `${item.name} (${item.ownerName})`}"
                :clearable="true"
                label="Филиал"
                placeholder="Поиск"
                class="mx-4"
                :item-value="value => value"
            />
          </v-col>
        </v-row>

        <v-divider/>

        <v-row class="ml-1 mr-1 pa-0">
          <v-col cols="12" md="4" class="pa-0">

          </v-col>
          <v-col cols="12" md="8" class="d-flex pa-0">
            <v-spacer/>

            <v-btn v-if="allowSignAllButton"
                   color="primary"
                   @click="onSignAllButton"
                   small
                   :disabled="signAllButtonDisabledState()"
            >
              <span>Подписать все на странице</span>
              <v-icon class="ml-1">{{ icons.mdiPencil }}</v-icon>
            </v-btn>

            <v-btn v-if="allowSignAllSelected"
                   color="primary"
                   @click="onSignAllSelectedButton"
                   small
                   :disabled="signAlSelectedButtonDisabledState(selected)"
            >
              <span>Подписать выбранные</span>
              <v-icon class="ml-1">{{ icons.mdiPencil }}</v-icon>
            </v-btn>

            <v-btn v-if="allowDownloadGreenListButton"
                   color="success"
                   small
                   @click="onDownloadGreenList"
                   class="ml-1"
            >
              <span>Зеленый реестр</span>
              <v-icon>save_alt</v-icon>
            </v-btn>

            <template v-if="allowDownloadGreenListButton">
              <v-text-field v-model="certificateSerial"
                            :dense="true"
                            label="Скачать зеленый реестр по сертификату"
                            class="ml-1"
              >
                <v-btn color="success" slot="append" small :disabled="!certificateSerial">
                  <v-icon @click="onDownloadGreenListBySerial">save_alt</v-icon>
                </v-btn>
              </v-text-field>
            </template>
            <v-btn class="ml-1"
                   color="primary"
                   @click="load()"
                   small
            >
              <span>Обновить</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template v-slot:item.rowNumber="scope">
      {{ getItemRowNumber(scope.item) }}
    </template>

    <template v-slot:item.contractor="scope">
      {{ scope.item.contractorName }}
      <br>
      <span>{{ scope.item.contractorInn }}</span>
    </template>

    <template v-slot:item.invoiceTotal="scope">
      {{ scope.item.invoiceTotal | decimalMinorCeilTwoDigit }}
    </template>

    <template v-slot:item.actions="scope">
      <!--Decline button-->
<!--      <template>
        <v-btn v-if="allowDeclineButtonFn(scope.item)"
               class="ml-1"
               color="warning" small
               @click="onDeclineButtonClicked(scope.item)"
        >
          Отклонить
        </v-btn>
        <v-btn v-else-if="disableNotAllowedDeclineButton"
               class="ml-1"
               color="warning" small
               :disabled="true"
        >
          Отклонить
        </v-btn>
      </template>-->


      <!--Sign button-->
      <template>
        <v-btn v-if="allowSignButtonFn(scope.item)"
               class="ml-1" color="primary" small
               @click="onSignButtonClicked(scope.item)"
        >
          Подписать
        </v-btn>
        <v-btn v-else-if="disableNotAllowedSignButton"
               class="ml-1"
               color="warning" small
               :disabled="true"
        >
          Подписать
        </v-btn>
      </template>

      <v-btn class="ml-1"
             color="info" small
             text
             :href="`https://my.soliq.uz/faktura/ru/factura/view/${scope.item.documentUniqueId}?type=buyer`"
             target="_blank"
      >
        Открыть
      </v-btn>
    </template>

    <template v-slot:footer.page-text="item">
      <div class="d-inline-flex mr-7">
        <v-text-field
            label="Перейти на страницу"
            type="number"
            v-model="page"
            @keyup.enter="onPageEntered"
        />
      </div>
      <div class="d-inline-flex">
        {{ item.pageStart }} - {{ item.pageStop }} из {{ item.itemsLength }}
      </div>
    </template>
  </v-data-table>
</template>

<script>
import ContractionService from "@/services/contraction.service";
import _ from 'underscore'
import {APP_FAKTURA_URL} from "@/settings";
import {mdiPencil} from "@mdi/js"

export default {
  name: "RoamingInvoiceList",
  props: {
    invoices: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    limitOptions: {
      type: Array,
      default: () => {
        return [10, 20];
      }
    },
    filters: {
      type: Object,
      default: () => {
        return {
          invoiceNumber: '',
          invoiceDate: null,
          contractor: '',
          signedDate: null,
          
          branch: null
        };
      }
    },
    pagination: {
      type: Object,
      default: () => {
        return {
          page: 1,
          limit: 10
        }
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    allowSignAllButton: {
      type: Boolean,
      default: false
    },
    allowSignButtonFn: {
      type: Function,
      default: () => {
        return false;
      }
    },
    allowDeclineButtonFn: {
      type: Function,
      default: () => {
        return false;
      }
    },
    signAllButtonDisabledState: {
      type: Function,
      default: () => {
        return true;
      }
    },
    signAlSelectedButtonDisabledState: {
      type: Function,
      default: (selectedList) => {
        return selectedList.length === 0;
      }
    },
    disableNotAllowedSignButton: {
      type: Boolean,
      default: true
    },
    disableNotAllowedDeclineButton: {
      type: Boolean,
      default: true
    },
    allowDownloadGreenListButton: {
      type: Boolean,
      default: false
    },
    allowSignedDateFilter: {
      type: Boolean,
      default: false
    },
    allowBranchFilter: {
      type: Boolean,
      default: false
    },
    allowActNumberColumn: {
      type: Boolean,
      default: true
    },

    showSelect: {
      type: Boolean,
      default: false
    },
    allowSignAllSelected: {
      type: Boolean,
      default: false
    },
    showCreatedAt: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: [],
      options: {
        page: 1,
        itemsPerPage: 10
      },
      page: 1,
      certificateSerial: null,

      // search contractor
      contractions: [],
      searchContractor: '',
      loadingContractor: false,

      // search branch
      branchOptions: [],

      filterInvoiceDateMenu: false,
      searchInvoiceNumber: '',

      filterSignedDateMenu: false,

      appFakturaHostUrl: APP_FAKTURA_URL,
      icons: {
        mdiPencil
      }
    };
  },
  computed: {
    headers() {
      const headers = [];

      headers.push({
        text: '№',
        align: 'center',
        sortable: false,
        value: 'rowNumber'
      });
      headers.push({
        text: 'Номер',
        align: 'center',
        sortable: false,
        value: 'invoiceNumber'
      });
      headers.push({
        text: 'Дата',
        align: 'center',
        sortable: false,
        value: 'invoiceDate'
      });
      headers.push({
        text: 'Сумма',
        align: 'center',
        sortable: false,
        value: 'invoiceTotal'
      });
      headers.push({
        text: 'Контрагент',
        align: 'center',
        sortable: false,
        value: 'contractor'
      });
      headers.push({
        text: 'Магазин',
        align: 'center',
        sortable: false,
        value: 'branchName'
      });

      if (this.allowActNumberColumn) {
        headers.push({
          text: 'Акт номер',
          align: 'center',
          value: 'actNumber',
          sortable: false,
        });
      }

      if (this.showCreatedAt)
        headers.push({
          text: 'Дата создания',
          align: 'center',
          sortable: false,
          value: 'createdOn'
        });

      headers.push({
        text: '',
        align: 'right',
        sortable: false,
        value: 'actions'
      });

      return headers;
    },
  },
  watch: {
    searchContractor(newValue) {
      this.searchContractorFromContractorList(newValue);
    },
    filters: {
      handler() {
        this.pagination.page = 1;

        if (this.options.page !== this.pagination.page)
          this.options.page = this.pagination.page;
        else
          this.load();

        this.page = this.pagination.page;
      },
      deep: true
    },
    invoices() {
      this.selected = [];
    }
  },
  methods: {
    load() {
      this.$emit('load');
    },
    getItemRowNumber(item) {
      const index = this.invoices.indexOf(item) + 1;
      return (this.options.page - 1) * this.options.itemsPerPage + index;
    },

    filterContractions(item, queryText) {
      return item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.inn.indexOf(queryText) > -1;
    },

    searchContractorFromContractorList: _.debounce(function (contractor) {
      this.loadingContractor = true;
      let query = this.filters.contractor ? this.filters.contractor : contractor;

      ContractionService.getAll({
        sortBy: null,
        sortDesc: true,
        skip: null,
        limit: 10,
        search: query
      })
          .then(response => {
            this.contractions = _.map(response.data.Records, contraction => {
              return {
                id: contraction.Id,
                code: contraction.OwnerSystemCode,
                name: contraction.ContractorName,
                inn: contraction.ContractorInn
              };
            });
          })
          .finally(() => {
            this.loadingContractor = false;
          });
    }, 1000),

    /*data table events*/
    onPagination(paginationProps) {
      this.pagination.page = paginationProps.page;
      this.pagination.limit = paginationProps.itemsPerPage;
      this.page = paginationProps.page;
      this.load();
    },

    searchInvoiceNumberInput: _.debounce(function () {
      this.filters.invoiceNumber = this.searchInvoiceNumber;
    }, 1000),

    /*buttons handlers*/
    onDownloadGreenList() {
      this.$emit('download-green-list', null);
    },
    onDownloadGreenListBySerial() {
      this.$emit('download-green-list-by-certificate', this.certificateSerial);
    },
    onSignButtonClicked(invoice) {
      this.$emit('sign', invoice);
    },
    onDeclineButtonClicked(invoice) {
      this.$emit('decline', invoice);
    },
    onSignAllButton() {
      this.$emit('sign-all');
    },
    onSignAllSelectedButton() {
      this.$emit('sign-selected-all', this.selected);
    },


    onPageEntered() {
      let setterValue = +this.page;
      let pages = this.total ? Math.ceil(this.total / this.options.itemsPerPage) : 0;
      if (Number.isInteger(setterValue)) {
        if (setterValue < 1) {
          this.$set(this.options, 'page', 1);
        } else if (setterValue > pages) {
          this.$set(this.options, 'page', pages);
        } else {
          this.$set(this.options, 'page', setterValue);
        }
      } else {
        this.$set(this.options, 'page', 1);
      }
    }
  },
  created() {
    this.$set(this.options, 'page', this.pagination.page);
    this.$set(this.options, 'itemsPerPage', this.pagination.limit);
  }
}
</script>